import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../Components/Header";
import NavBar from "../Components/NavBar";
import useAuth from "../useAuth";
import { IoIosArrowDroprightCircle } from "react-icons/io";

export default function EntryPage() {
  const { user, menuOpen, changeMenuSize, logout } = useAuth();
  const location = useLocation();
  const pathname = location.pathname.split("/")[2];

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (user?.userType !== "admin") {
    return (
      <div className="min-h-screen flex flex-col justify-center items-center bg-gray-50 text-center px-4">
        <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 max-w-sm w-full space-y-4">
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto">
            <svg
              className="w-8 h-8 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-900">Access Denied</h2>
            <p className="text-sm text-gray-500 mt-2">
              You must be an administrator to access this application.
            </p>
          </div>
          <button
            onClick={logout}
            className="w-full bg-gray-900 hover:bg-gray-800 text-white font-medium py-2.5 px-4 rounded-xl transition-all active:scale-[0.98]"
          >
            Sign Out
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex">
      <div
        className={` ${
          menuOpen ? "w-72" : "w-24"
        } z-50 transition-all duration-700 fixed top-0`}
      >
        <div className="h-screen bg-white border-r border-gray-200 relative">
          <div className="h-full overflow-y-hidden">
            <NavBar />
          </div>

          <div className="absolute top-4 -right-3 z-[60]">
            <IoIosArrowDroprightCircle
              className={`text-blue-600 text-2xl bg-white rounded-full shadow-md cursor-pointer transition-transform duration-300 border border-gray-100 hover:scale-110 ${
                menuOpen ? "rotate-180" : "rotate-0"
              }`}
              onClick={changeMenuSize}
            />
          </div>
        </div>
      </div>

      <div
        className={`${
          menuOpen ? "ml-72" : "ml-24"
        } transition-all duration-700 w-full bg-slate-300}`}
      >
        <div className="sticky z-30 top-0">
          <Header />
        </div>
        <div className="p-4 min-h-screen z-10 bg-gradient-to-b from-gray-50 to-gray-100 text-gray-800">
          {<Outlet />}
        </div>
        {pathname !== "grievancesMsgs" && (
          <div className="px-4 py-4 border-t-[0.1px] text-xs text-slate-900 mx-4 border-gray-400">
            COPYRIGHT - BRAVISHMAH INFOTECH PRIVATE LIMITED
          </div>
        )}
      </div>
    </div>
  );
}
